import React from 'react';
import { motion } from 'framer-motion';
import { SearchIcon, FilterIcon, HeartIcon, EyeIcon, ListOrderedIcon, HelpCircleIcon, CompassIcon, XIcon, ShieldIcon } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
export function ContentsSection() {
  const contents = [{
    text: 'Las señales silenciosas de que una relación se está enfriando por dentro aunque siga funcionando por fuera.',
    icon: SearchIcon
  }, {
    text: 'Cómo distinguir entre una etapa difícil y una desconexión emocional real.',
    icon: FilterIcon
  }, {
    text: 'Qué pasa cuando una mujer sostiene sola la carga emocional del hogar durante demasiado tiempo.',
    icon: HeartIcon
  }, {
    text: 'Por qué ya no te sientes elegida, mirada o emocionalmente acompañada.',
    icon: EyeIcon
  }, {
    text: 'Cómo ordenar lo que sientes sin caer en culpa, negación o impulso.',
    icon: ListOrderedIcon
  }, {
    text: 'Qué preguntas hacerte para entender si aún hay base para reconstruir.',
    icon: HelpCircleIcon
  }, {
    text: 'Cómo dejar de vivir confundida y recuperar tu centro emocional.',
    icon: CompassIcon
  }];
  const wontDo = ['No te va a obligar a separarte.', 'No te va a obligar a quedarte.', 'No te va a juzgar.', 'No te va a llenar de frases vacías.', 'No te va a empujar a tomar decisiones apresuradas.'];
  return <section className="py-8 md:py-12 px-6 bg-[#FFF8F0]" data-id="element-77">
      <div className="max-w-3xl mx-auto" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-10" data-id="element-79">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-80">
            QUÉ ENCONTRARÁS DENTRO
          </h2>

          <ul className="space-y-4" data-id="element-81">
            {contents.map((item, index) => {
            const Icon = item.icon;
            return <li key={index} className="flex items-start gap-4" data-id="element-82">
                  <div className="mt-1 bg-softGold/20 p-1.5 rounded-full" data-id="element-83">
                    <Icon className="w-5 h-5 text-terracotta flex-shrink-0" data-id="element-84" />
                  </div>
                  <span className="text-lg text-mutedBrown leading-relaxed" data-id="element-85">
                    {item.text}
                  </span>
                </li>;
          })}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-warmWhite p-6 md:p-8 rounded-2xl border border-softGold/30" data-id="element-86">
          <h3 className="text-2xl font-bold mb-6 text-center text-warmBrown" data-id="element-87">
            LO QUE ESTA GUÍA NO HARÁ
          </h3>

          <ul className="space-y-3 mb-8" data-id="element-88">
            {wontDo.map((item, index) => <li key={index} className="flex items-center gap-3" data-id="element-89">
                <XIcon className="w-5 h-5 text-mutedBrown/60 flex-shrink-0" data-id="element-90" />
                <span className="text-mutedBrown" data-id="element-91">{item}</span>
              </li>)}
          </ul>

          <div className="pt-6 border-t border-softGold/20" data-id="element-92">
            <h4 className="text-xl font-bold text-terracotta mb-3" data-id="element-93">
              Lo que sí hará:
            </h4>
            <p className="text-lg text-warmBrown leading-relaxed font-medium" data-id="element-94">
              Te ayudará a entender. Y una mujer que entiende con claridad su
              realidad emocional deja de vivir atrapada en la niebla, la culpa y
              la confusión.
            </p>
          </div>
        </motion.div>

        <div className="mt-10" data-id="element-95">
          <CTAButton text="QUIERO ENTENDER SIN PRESIÓN" icon={<ShieldIcon className="w-5 h-5" data-id="element-97" />} data-id="element-96" />
        </div>
      </div>
    </section>;
}